// PaymentSuccess.jsx
import React from "react";
import "./payment.css";

export default function PaymentSuccess() {
  return (
    <div className="payment-container success">
      <img src="/belmarket.png" alt="BelMarket Logo" className="logo" />

      <h1>Paiement effectué avec succès 🎉</h1>
      <p>Merci pour votre achat sur BelMarket.</p>

      {/*
          <button onClick={() => (window.location.href = "/")} className="btn">
        Retour à l’accueil
      </button> */}
    </div>
  );
}
